module.exports = __webpack_public_path__ + "thumbnail-0d11ff6b568c366750b95f19456401da.png";